export function cleanText(input) {
  let cleaned = input;
  // 1. Remove URLs with Markdown formatting: [text](url)
  cleaned = cleaned.replace(/\[([^\]]+)]\((https?:\/\/[^\s)]+)\)/gi, "$1");

  // 2. Remove simple URLs
  cleaned = cleaned.replace(/https?:\/\/[^\s]+/gi, "");

  // 3. Remove the word “stedi” (case-insensitive)
  cleaned = cleaned.replace(/\bstedi\b/gi, "");

  // 4. Cleans up extra spaces by removing words
  cleaned = cleaned
    .replace(/\bin the docs\b/gi, "") // "in the docs"
    .replace(/\[docs\]/gi, "") // "[docs]"
    .replace(/\bdocs\b/gi, ""); // "docs"

  // 5. Cleans extra spaces and double points
  cleaned = cleaned
    .replace(/\s{2,}/g, " ")
    .replace(/\s+\./g, ".")
    .trim();

  return cleaned;
}
